/**
 * @ignore
 * Created by Shanie on 12/15/16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import QueryLookupRenderer from 'relay-query-lookup-renderer';
import rootQuery from '../queries/favoritesRoot';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { connect } from 'react-redux';

import { sortBy, tabs } from './constants';

// Helpers
import SV from 'server-vars';
import actions from './actions/FavoritesActions';
import { getBuyerId, getUserType } from 'dibs-cookie-jar';
import { addLoginHandlers } from 'dibs-buyer-layout/src/entries/index';

// Components
import Error from './components/Error';
import FavoritesContainer from './components/FavoritesContainer';

class FavoritesRenderer extends React.Component {
    constructor(props) {
        super(props);

        this.showFullPageOverlay = this.showFullPageOverlay.bind(this);
    }

    componentDidMount() {
        addLoginHandlers(() => {
            location.reload();
        });
    }

    showFullPageOverlay({ searchTerm, tab, userHasChanged } = {}) {
        switch (true) {
            case this.props.searchTerm !== searchTerm:
            case this.props.tab !== tab:
            case userHasChanged:
                return true;
            default:
                return false;
        }
    }

    render() {
        const {
            first,
            portfolioDoesNotExist,
            portfolioIds,
            portfolioViewPermission,
            portfolioTypes,
            projectId,
            searchTerm,
            showSeller,
            tab,
            page,
        } = this.props;

        const userId = this.props.userId || getBuyerId(document.cookie) || '';
        const isTrade = this.props.isTrade || getUserType(document.cookie) === 'trade';

        const isFolder = tab === tabs.FOLDER && !!portfolioViewPermission;
        const isProject = tab === tabs.PROJECT;
        const variables = {
            after: null,
            first,
            hasUserId: !!userId,
            portfolioIds: portfolioIds && portfolioIds.length ? portfolioIds : null,
            portfolioTypes: portfolioTypes.length ? portfolioTypes : null,
            projectId,
            searchTerm,
            sortBy: sortBy.CUSTOM,
            foldersSort: sortBy.CUSTOM,
            loadPortfolioData: !!userId,
            selectedItemIds: [],
            userId,
            userIds: [userId],
            useProjectEndpoint: !!projectId,
            isItems: tab === tabs.ITEMS,
            isFolders: tab === tabs.FOLDERS,
            isFollowing: tab === tabs.FOLLOWING,
            isSinglePortfolio: isFolder || isProject,
            isProjects: tab === tabs.PROJECTS,
            isTrade,
            showSeller,
            tab,
            page,
        };

        const environment = getRelayEnvironment(SV.get('favorites.records'));

        return (
            <QueryLookupRenderer
                lookup
                retain
                environment={environment}
                query={rootQuery}
                variables={variables}
                render={({ error, props: relayProps }) => {
                    if (error) {
                        return <Error />;
                    } else if (relayProps) {
                        this.prevProps = {
                            ...variables,
                            ...relayProps,
                        };
                        return (
                            <FavoritesContainer
                                {...this.prevProps}
                                portfolioDoesNotExist={portfolioDoesNotExist}
                            />
                        );
                    } else {
                        const showFullPageOverlay = this.showFullPageOverlay(this.prevProps);
                        return (
                            <FavoritesContainer
                                {...this.prevProps}
                                tab={tab}
                                isFullPageOverlay={showFullPageOverlay}
                                portfolioDoesNotExist={portfolioDoesNotExist}
                            />
                        );
                    }
                }}
            />
        );
    }
}

FavoritesRenderer.propTypes = {
    first: PropTypes.number,
    isTrade: PropTypes.bool,
    portfolioDoesNotExist: PropTypes.bool,
    portfolioIds: PropTypes.array,
    portfolioTypes: PropTypes.array,
    portfolioViewPermission: PropTypes.bool,
    projectId: PropTypes.string,
    showSeller: PropTypes.bool,
    tab: PropTypes.string,
    userHasChanged: PropTypes.bool,
    userId: PropTypes.string,
};

const mapStateToProps = state => {
    return {
        portfolioDoesNotExist: state.favorites.uiState.portfolioDoesNotExist,
        portfolioIds: state.favorites.uiState.portfolioIds,
        portfolioViewPermission: state.favorites.uiState.portfolioViewPermission,
        portfolioTypes: state.favorites.uiState.portfolioTypes,
        projectId: state.favorites.uiState.projectId,
        tab: state.favorites.uiState.tab,
        userHasChanged: state.favorites.uiState.userHasChanged,
    };
};

export default connect(mapStateToProps)(FavoritesRenderer);
